import { render } from "./RemoteSelect.vue?vue&type=template&id=1d16f790"
import script from "./RemoteSelect.vue?vue&type=script&lang=ts"
export * from "./RemoteSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script